import React from "react";
import { connect } from "react-redux";
import {
  removeField,
  handleHideStake,
} from "../../../redux/actions/betSlipActions";
import { Tooltip, Input, Spin, Icon, Select } from "antd";
import { SportIcon, Alert } from "../../";
import { SessionStorage, Cookies, Enums } from "../../../helpers";
import Images from "../Images";
import moment from "moment";
import { onAmountChange } from "../../../redux/actions/betSlipActions";
import { setPossibleWinnings  , setTotalStake} from "../../../redux/actions/betSlipActions";
import CustomDropdown from "./CustomDropDown";
const Option = Select.Option;

class BetSlipRow extends React.Component {
  state = {
    changeStatus: 0,
    selection: this.props.betSlipField.selectedDrawsIds && this.props.betSlipField.selectedDrawsIds
  };
  checkImage = (teamId) => {
    this.setState({
      [teamId]: true,
    });
  };
  // componentDidMount(){
  //   const {betSlipField ,possibleWinnings , totalStake , setTotalStake , setPossibleWinnings , amount} =this.props;
    
  //   if(betSlipField && betSlipField.selectedDrawsIds && betSlipField.possibleFieldWin && betSlipField.selectedDrawsIds.length > 1){
  //     let length  =betSlipField.selectedDrawsIds.length
  //     let calcTotalStake;
  //     let calcPossibleWinning;
  //     calcTotalStake =totalStake + ( amount * (length==1 ? length :length -1))
  //     setTotalStake( calcTotalStake)
  //   }
  // }

  onAmountClick = (e, action, amount, betSlipField, selectedCurrency) => {
    e.preventDefault();
    let currentAmount = parseInt(amount);
    switch (action) {
      case "up":
        currentAmount += selectedCurrency.currencyId === 1 ? 10 : 1;
        break;

      case "down":
        if (currentAmount - (selectedCurrency.currencyId === 1 ? 10 : 1) >= 0) {
          currentAmount -= selectedCurrency.currencyId === 1 ? 10 : 1;
        } else {
          currentAmount = 0;
        }
        break;
    }
    this.props.onFieldAmountChange(
      currentAmount,
      betSlipField.activeOddFieldId
    );
    this.props.handleHideStake();
  };

  componentDidUpdate(prevProps, prevState) {

    if (this.props.betSlipField.oddValue !== prevProps.betSlipField.oddValue) {
      this.setState({ changeStatus: 0 }, () => {
        setTimeout(
          () =>
            this.setState({
              changeStatus: this.props.betSlipField.oddValueStatus,
            }),
          10
        );
      });
    }
  }
  handleSelect = (value , betSlipField) => {
    this.setState({
      selection:value
    })
    const {possibleWinnings , totalStake , setTotalStake , setPossibleWinnings , amount}= this.props
    const inputLength = value.length
    let betSlip = SessionStorage.betSlip;
    let id = Number(value)
    Object.values(betSlip).map((item) => {
      if ( item.drawEvents && item.key == betSlipField.key) {
          let values=[];
          item.drawEvents.map(item=>{
            value.map(ele=>{
              if(item.eventId == ele){
                values.push(item)
              }
            })
  
          }) 
          item.selectedDraws = values
          item.selectedDrawsIds = value
      }
    });
    let calcTotalStake;
    let calcPossibleWinning;;
    if(inputLength <= this.state.selection.length ){

      calcTotalStake =totalStake -( amount )
      calcPossibleWinning =possibleWinnings -(betSlipField.possibleFieldWin )

    }else if(inputLength > this.state.selection.length ){
      calcTotalStake =totalStake + ( amount )
      calcPossibleWinning =possibleWinnings + (betSlipField.possibleFieldWin )
    }
    setTotalStake( calcTotalStake)
    setPossibleWinnings( calcPossibleWinning)
    SessionStorage.betSlip = betSlip
  }

  render() {
    const {
      betSlipField,
      loadingPlaceBet,
      memberSelectedCurrency,
      isDark,
    } = this.props;
    // const image = `${betSlipField.feed.feedId}${betSlipField.sport.sportId}.webp`;


    let betTab = SessionStorage.betTab;
    const selectedCurrency =
      memberSelectedCurrency || Cookies.get("selectedCurrency");
    const spinner = (
      <Icon type="loading" style={{ fontSize: 24 }} spin={loadingPlaceBet} />
    );
    let hasResponse = betSlipField.response !== undefined;
    return (
      <div className="event">
        <div style={{ display: "flex", flexDirection: "row" }} className="text">
          <div
            style={{ width: "80%", display: "flex", flexDirection: "column" }}
          >
            {/* <SportIcon
              feedId={betSlipField.feed.feedId}
              sportId={betSlipField.sport.sportId}
            /> */}
            <div
              className="teams"
              // onClick={() => this.navToDrillDown()}
              style={{
                width: "90%",
                display: "inline-block",
                justifyContent: "center",
              }}
            >
              {betSlipField.feed.feedId === 5 && (
                <div className="live">Live</div>
              )}

              <div className="bet-slip-teams-container">
                {betSlipField.feed.feedId === Enums.Feed.Casino ||
                betSlipField.feed.feedId === Enums.Feed.SpinAndWin ? (
                  <div>
                    {betSlipField.eventDisplayName} -{" "}
                    {betSlipField.eventBetLineNo}
                  </div>
                ) : (
                  <div>
                    {betSlipField.feed.feedId === Enums.Feed.LuckyNumbers ? (
                      <>
                        <div className="bet-slip-teams">
                          <span className="team-name-abbreviation">
                            {betSlipField &&
                              betSlipField.eventTournament &&
                              betSlipField.eventTournament
                                .tournamentDisplayName}
                          </span>
                        </div>
                        {betSlipField.selectedNumbers && (
                          <div className="balls-container">
                            {betSlipField.selectedNumbers && betSlipField.selectedNumbers
                              .split(",")
                              .map(Number)
                              .map((item) => {
                                return (
                                  <div className="balls selected" key={item}>
                                    {item}
                                  </div>
                                );
                              })}
                          </div>
                        )}
                        {betSlipField.selectedBonuses && (
                          <div className="balls-container">
                            {betSlipField.selectedBonuses
                              .split(",")
                              .map(Number)
                              .map((item) => {
                                return (
                                  <div
                                    className="balls bonus-selected"
                                    key={item}
                                  >
                                    {item}
                                  </div>
                                );
                              })}
                          </div>
                        )}
                        {/* eventBetLineNo
                        eventDateOfMatch
                        eventId */}
                        {/* {betSlipField.drawEvents && (
                          <Select
                            style={{ width: "100%" }}
                            mode="multiple"
                            autoComplete="off"
                            placement="bottom"
                            className="loyality-rewards-select next-draws-select"
                            filterOption={true}
                            placeholder="Select Draws"
                            popupPlacement="bottomLeft" // Set the popup placement to "bottomLeft"
                            showArrow={true}
                            defaultValue={betSlipField.selectedDrawsIds ? betSlipField.selectedDrawsIds :  (betSlipField.drawEvents[0].eventId) }
                            getPopupContainer={(trigger) => trigger.parentNode}
                            onChange={(e) =>
                              this.handleSelect(e , betSlipField)
                            }
                          >
                            {betSlipField.drawEvents.map((item , idx) => {
                              return (
                                <Option
                                  value={item.eventId}
                                  key={item.eventId}
                                  disabled={idx == 0}
                                >
                                  {moment(item.eventDateOfMatch).format(
                                    "DD MMM YYYY, HH:mm:ss"
                                  )}
                                </Option>
                              );
                            })}
                          </Select>
                        )} */}
                        {betSlipField.drawEvents && (
                         <CustomDropdown betSlipField={betSlipField} drawEvents={betSlipField.drawEvents} handleSelect={this.handleSelect}/>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="bet-slip-teams">
                          <span className="team-name-abbreviation">
                            {betSlipField.homeTeamName &&
                              betSlipField.homeTeamName[0]}
                            {betSlipField.homeTeamName &&
                              betSlipField.homeTeamName.split(" ").length > 1 &&
                              betSlipField.homeTeamName.split(" ")[1][0]}
                          </span>
                          {betSlipField.feed.feedId != Enums.Feed.Casino &&
                            betSlipField.feed.feedId != Enums.Feed.SpinAndWin &&
                            betSlipField.eventDisplayName && (
                              <span>
                                {" "}
                                {betSlipField.eventDisplayName.split("Vs.")[0]}
                              </span>
                            )}
                          {betSlipField.feed.feedId == Enums.Feed.Casino ||
                            (betSlipField.feed.feedId ==
                              Enums.Feed.SpinAndWin &&
                              `- ${betSlipField.eventBetLineNo}`)}

                          <span style={{ fontSize: "16px" }}>
                            <p
                              style={{
                                color: "#2d8af7",
                                display: "inline",
                                fontWeight: "bold",
                                fontSize: "13px",
                              }}
                            >
                              Vs{" "}
                            </p>
                          </span>
                        </div>
                        <div className="bet-slip-teams">
                          <span className="team-name-abbreviation">
                            {betSlipField.awayTeamName &&
                              betSlipField.awayTeamName[0]}
                            {betSlipField.awayTeamName &&
                              betSlipField.awayTeamName.split(" ").length > 1 &&
                              betSlipField.awayTeamName.split(" ")[1][0]}
                          </span>
                          {/* {!this.state[betSlipField.awayTeamId] && (
                    <img
                      src={`${AppConfig.api.teamIcons}${betSlipField.awayTeamId}_s.png`}
                      height="18px"
                      width="18px"
                      onError={() => this.checkImage(betSlipField.awayTeamId)}

                    />
                  )}
                                    {this.state[betSlipField.awayTeamId] && betSlipField.awayTeamName && 
                  betSlipField.awayTeamName.includes(' ') &&
                  betSlipField.awayTeamName.split(" ").length >= 2 ? (
                    <div
                      style={
                        betSlipField.awayTeamColor &&
                        betSlipField.awayTeamColor != "ffffff"
                          ? {
                              backgroundColor: `#${betSlipField.awayTeamColor}`,
                            }
                          : { backgroundColor: "#AEB4BF" }
                      }
                      className="events-alternative-image"
                    >
                      {" "}
                      <span>{betSlipField.awayTeamName.split(" ")[0][0]}</span>
                      <span>{betSlipField.awayTeamName.split(" ")[1][0]}</span>
                    </div>
                  ) : this.state[betSlipField.awayTeamId] ? (
                    <div
                      style={
                        betSlipField.awayTeamColor &&
                        betSlipField.awayTeamColor != "ffffff"
                          ? {
                              backgroundColor: `#${betSlipField.awayTeamColor}`,
                            }
                          : { backgroundColor: "#AEB4BF" }
                      }
                      className="events-alternative-image"
                    >
                      {" "}
                      <span>{betSlipField.awayTeamName && betSlipField.awayTeamName.split(" ")[0][0]}</span>
                    </div>
                  ) : (
                    ""
                  )} */}
                          <span>
                            {betSlipField.eventDisplayName &&
                              betSlipField.eventDisplayName.split("Vs.")[1]}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="icon">
              {betSlipField.errors &&
                betSlipField.errors.length > 0 &&
                betTab == 2 && (
                  <Tooltip
                    title={betSlipField.errors.map((item, index) => (
                      <div key={index}>{` * ${item}`}</div>
                    ))}
                  >
                    <div className="alert-icon error">!</div>
                  </Tooltip>
                )}
            </div>
            <div className="text">
              <div
                style={{ opacity: "0.5", fontSize: "12px" }}
                className="odd-name"
              >
                {betSlipField.betType.betTypeName}
              </div>
            </div>
            <div className="text odds">
              <div className="icon" />
              <div>
                <div className="team">{betSlipField.betType.specialTemplateName ? betSlipField.oddField : betSlipField.oddFieldDisplayName}</div>
              </div>
            </div>
          </div>
          {/* separator comment */}

          <div
            style={{
              width: "20%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              className="close"
              onClick={() => this.removeField(betSlipField)}
            >
              <img
                src={
                  localStorage.getItem("theme") &&
                  localStorage.getItem("theme") == "dark"
                    ? Images.BinIcon
                    : Images.RedBinIcon
                }
                alt="bin-icon"
                height="17px"
                width="17px"
              />
              {/* <Icon type="delete" theme="filled"/> */}
            </div>
            <div
              className={`odd-value ${
                this.state.changeStatus == 1 ? "up" : ""
              } ${this.state.changeStatus == -1 ? "down" : ""}`}
            >
              {betSlipField.enableBet &&
              betSlipField.eventEnableBet &&
              betSlipField.oddEnableBet &&
              betSlipField.oddValue &&
              !betSlipField.notAvailable ? (
                betSlipField.oddValue.format(2)
              ) : betSlipField.notAvailable ? (
                <div className="text"> No Longer Available</div>
              ) : (
                <Icon type="lock" />
              )}
            </div>
          </div>
        </div>

        {/* ====================================================================== */}
        {/* Mounting component and possible winnings score in the uppper of the bits details component */}
        {betTab &&
          betTab == 1 &&
          (hasResponse
            ? hasResponse && betSlipField.response.type !== "success"
            : true) && (
            <div className="row-amount">
              <div className="amount-up-down">
                <div
                  className="up"
                  onClick={(e) =>
                    this.onAmountClick(
                      e,
                      "down",
                      betSlipField.amount,
                      betSlipField,
                      selectedCurrency
                    )
                  }
                >
                  <Icon type="minus" />
                </div>
                <div className="amount">
                  <Input
                    type="number"
                    value={betSlipField.amount || 0}
                    className="input"
                    placeholder="Amount"
                    onChange={(e, value) =>
                      this.onAmountClick(
                        e,
                        "manual",
                        e.target.value,
                        betSlipField
                      )
                    }
                  />
                </div>
                <div
                  className="down"
                  onClick={(e) =>
                    this.onAmountClick(
                      e,
                      "up",
                      betSlipField.amount,
                      betSlipField,
                      selectedCurrency
                    )
                  }
                >
                  <Icon type="plus" />
                </div>
              </div>
              {/* <div className="currency">
                {selectedCurrency ? selectedCurrency.currencySymbol : "LD"}
              </div> */}
            </div>
          )}
        {loadingPlaceBet &&
          betTab == 1 &&
          (!hasResponse || betSlipField.response.type === "error") && (
            <Spin indicator={spinner} />
          )}
        {betTab &&
          betTab == 1 &&
          (hasResponse
            ? hasResponse && betSlipField.response.type !== "success"
            : true) && (
            <div className="row-total-possible">
              <div className="total-possible">Possible winnings: </div>
              <div className="total-possible-value">
                {`${selectedCurrency ? selectedCurrency.currencySymbol : "LD"}
						${
              selectedCurrency.currencySymbol === "LD" &&
              betSlipField &&
              betSlipField.possibleFieldWin
                ? betSlipField.possibleFieldWin.format(0)
                : betSlipField && betSlipField.possibleFieldWin
                ? betSlipField.possibleFieldWin.format(2)
                : ""
            }`}
              </div>
            </div>
          )}
        {betSlipField.errors &&
          betSlipField.errors.length > 0 &&
          betTab == 1 &&
          betSlipField.errors.map((item, index) => (
            <Alert key={index} message={item} type="error" icon="!" />
          ))}
        {betSlipField.oddValueStatus !== 0 && (
          <Alert message={"Bet value changed"} type="warning" icon="!" />
        )}
        {hasResponse && betSlipField.response.type === "success" && (
          <div style={{ background: "#00800036" }}>
            <Alert
              key={betSlipField.response.betLine}
              message={betSlipField.response.message}
            />
          </div>
        )}
        {hasResponse && betSlipField.response.type === "error" && (
          <Alert
            key={betSlipField.response.betLine}
            type={betSlipField.response.type}
            icon={"!"}
            message={betSlipField.response.message}
          />
        )}
      </div>
    );
  }

  removeField(field) {
    const { removeField } = this.props;
    removeField(field);
  }

  navToDrillDown() {
    const { history, feedName, match, betSlipField, feedId } = this.props;
    if (
      match.params.feed == Enums.Feed.Casino ||
      match.params.feed == Enums.Feed.SpinAndWin
    )
      history.push(
        `/${feedName}/${match.params.feed}/${match.params.sport}/${betSlipField.eventDisplayName}/${betSlipField.eventId}`
      );
    else
      history.push(
        `/${feedName}/${feedId}/${match.params.sport}/${match.params.sportName}/event/${betSlipField.eventCategory.sportCategoryId}/${betSlipField.eventTournament.tournamentId}/${betSlipField.eventId}`
      );
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    betSlipField: state.betSlip.betSlipList[initialProps.data.activeOddFieldId],
    amount: state.betSlip.amount,
    memberSelectedCurrency: state.member.selectedCurrency,
    isDark: state.app.isDark,
    possibleWinnings: state.betSlip.possibleWinnings,
    totalStake: state.betSlip.totalStake,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    removeField: (field) => {
      dispatch(removeField(field));
    },
    handleHideStake: () => {
      dispatch(handleHideStake());
    },
    onAmountChange: (amount) => {
      dispatch(onAmountChange(amount));
    },
    setTotalStake: (value) => {
      dispatch(setTotalStake(value));
    },
    setPossibleWinnings: (value) => {
      dispatch(setPossibleWinnings(value));
    },
    
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BetSlipRow);
